import axiosClient from "../axiosClient";
import API_MAP from "../../constants/api";
import { CONFIG_CODE_GET } from "constants/common";

class ApiManagerSystem {
    getOneConfig = (code) => {
        return axiosClient.get(API_MAP.GET_ONE_CONFIG + `?code=${code}`)
    }
    getConfig = (data) => {
        const { code, value, description, currentPage, limit } = data
        return axiosClient.get(API_MAP.GET_CONFIG + `?code=${code}&value=${value}&description=${description}&page=${currentPage}&size=${limit}`)
    }
    createConfig = (data) => {
        return axiosClient.post(API_MAP.CREATE_CONFIG, data)
    }
    updateConfig = (data) => {
        return axiosClient.post(API_MAP.UPDATE_CONFIG, data)
    }
    deleteConfig = (data) => {
        return axiosClient.post(API_MAP.DELETE_CONFIG, data)
    }
    getConfigSystems = () => {
        return axiosClient.get(`${API_MAP.SYSTEM.GET_CONFIGS}?configsCode=${CONFIG_CODE_GET.join()}`)
    }
    changePortWebAdmin = (data) => {
        return axiosClient.post(API_MAP.SYSTEM.CHANGE_ADMIN_PORT, data)
    }
    getListUnits = ({ page = 0, size = 5, is_active, code_or_name = "", parent_unit_id = "", function_code = "" }) => {
        return axiosClient.get(API_MAP.SYSTEM.UNIT.GET_LIST + `?page=${page}&size=${size}` + (code_or_name ? `&code_or_name=${code_or_name}` : '') + ((is_active === 1 || is_active === 0) ? `&is_active=${is_active}` : '') + (parent_unit_id ? `&parent_unit_id=${parent_unit_id}` : '') + (function_code ? `&function_code=${function_code}` : ''));
    }
    getTreeUnit = () => {
        return axiosClient.get(API_MAP.SYSTEM.UNIT.FULL_TREE);
    }
    getTree = ({function_code, name}) => {
        return axiosClient.get(API_MAP.SYSTEM.UNIT.TREE + (function_code ? `?function_code=${function_code}`: '') + (name ? `&name=${name}` : ''));
    }
    deleteUnit = (id) => {
        return axiosClient.get(API_MAP.SYSTEM.UNIT.DELETE_UNIT + `/${id}`)
    }
    getUnitUser = ({ page = 0, size = 5, is_active, name_or_email = "", id }) => {
        return axiosClient.get(API_MAP.SYSTEM.UNIT.USER + `/${id}/users?page=${page}&size=${size}` + (name_or_email ? `&name_or_email=${name_or_email}` : '') + ((is_active === 1 || is_active === 0) ? `&is_active=${is_active}` : ''))
    }
    getPosition = ({ page = 0, size = 5, is_active, code_or_name = "", unit_id }) => {
        return axiosClient.get(API_MAP.SYSTEM.UNIT.GET_POSITION + `?page=${page}&size=${size}&unit_id=${unit_id}` + (code_or_name ? `&code_or_name=${code_or_name}` : '') + ((is_active === 1 || is_active === 0) ? `&is_active=${is_active}` : ''))
    }
    addUnit = (body) => {
        return axiosClient.post(API_MAP.SYSTEM.UNIT.ADD_UNIT, body);
    }
    editUnit = (body) => {
        return axiosClient.post(API_MAP.SYSTEM.UNIT.EDIT_UNIT, body);
    }
}

const apiManagerSystem = new ApiManagerSystem();

export default apiManagerSystem;
